import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(private http: HttpClient) { }

  public getCountries(page: any) {
    return this.http.post<any>("/api/v1/amjam/authentication/country/getcountrybypagination", page);
  }

  public searchKey(page: any) {
    return this.http.post<any>("/api/v1/amjam/authentication/country/search", page);
  }

  public add(data: any) {
    return this.http.post<any>("/api/v1/amjam/authentication/country/add", data);
  }

  public delete(id: any) {
    return this.http.delete<any>("/api/v1/amjam/authentication/country/delete/" + id);
  }

  public get(id: any) {
    return this.http.get<any>("/api/v1/amjam/authentication/country/get/" + id);
  }

}
